var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g2, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 225,
    height: 192,
    viewBox: "0 0 225 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224.82 115.041L162.474 151.293L94.4812 111.811L156.337 75.063L224.82 115.041Z",
    fill: "url(#paint0_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.8769 113.399L94.4893 191.142L26.3777 151.783L26.5123 74.0889L94.8769 113.399Z",
    fill: "#CFEEFF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.7639 34.9023L94.6293 112.096L26.3777 151.783L26.5123 74.0886L94.7639 34.9023Z",
    fill: "#C5EBFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.735 74.1693L162.488 151.293L94.6292 112.096L94.7637 34.9023L162.735 74.1693Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M131.115 145.391C128.949 144.13 128.507 142.249 129.788 140.745C129.659 140.81 129.529 140.877 129.405 140.948C126.691 142.511 126.696 145.07 129.417 146.656C132.137 148.238 136.555 148.255 139.27 146.692C139.822 146.374 140.258 146.014 140.588 145.631C137.854 146.985 133.711 146.901 131.115 145.391Z",
    fill: "url(#paint1_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M159.287 134.789C154.424 131.981 146.93 131.615 141.405 133.691L141.363 133.708C141.312 133.727 141.261 133.747 141.208 133.767L131.301 137.605L134.922 137.444L135.792 137.763C133.934 140.703 135.046 144.141 139.132 146.501C140.374 147.216 141.785 147.774 143.294 148.174L144.387 155.186L159.352 146.501C164.911 143.271 164.88 138.016 159.287 134.789Z",
    fill: "url(#paint2_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M141.087 143.676L141.07 149.348C141.073 148.329 140.402 147.306 139.056 146.532C136.384 144.989 132.05 144.989 129.397 146.532C128.079 147.298 127.417 148.303 127.415 149.309L127.431 143.637C127.434 142.632 128.093 141.626 129.414 140.86C132.07 139.317 136.403 139.317 139.073 140.86C140.419 141.635 141.089 142.657 141.087 143.676Z",
    fill: "#EC6600"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M148.549 143.696L148.532 149.368C148.527 151.474 147.144 153.578 144.384 155.183C138.828 158.413 129.758 158.413 124.165 155.183C121.352 153.558 119.943 151.421 119.952 149.286L119.969 143.615C119.963 145.749 121.368 147.886 124.182 149.511C129.774 152.741 138.845 152.741 144.401 149.511C147.164 147.909 148.544 145.805 148.549 143.696Z",
    fill: "#F97800"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M131.115 145.245C128.949 143.983 128.507 142.102 129.788 140.598C129.659 140.663 129.529 140.731 129.405 140.801C126.691 142.364 126.696 144.924 129.417 146.509C132.137 148.092 136.555 148.109 139.27 146.546C139.822 146.228 140.258 145.867 140.588 145.484C137.854 146.839 133.711 146.757 131.115 145.245Z",
    fill: "url(#paint3_radial)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M144.336 137.799C149.929 141.029 149.96 146.281 144.401 149.511C138.845 152.742 129.774 152.742 124.182 149.511C118.589 146.281 118.561 141.027 124.117 137.799C129.673 134.569 138.743 134.572 144.336 137.799ZM129.445 146.453C132.117 147.996 136.448 147.996 139.104 146.453C141.759 144.91 141.745 142.401 139.073 140.858C136.4 139.314 132.067 139.314 129.414 140.858C126.758 142.401 126.772 144.91 129.445 146.453Z",
    fill: "#FFA431"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M117.39 100.527L94.6992 113.712L71.8645 100.53L94.5518 87.3447L117.39 100.527Z",
    fill: "#00B3FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M117.389 100.53L117.317 152.929L94.6301 166.115L94.6987 113.716L117.389 100.53Z",
    fill: "#008CD6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6986 113.716L94.6301 166.115L71.792 152.933L71.8639 100.53L94.6986 113.716Z",
    fill: "#46D6FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M146.093 152.097L130.686 163.864L109.817 153.132L146.093 152.097Z",
    fill: "url(#paint4_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M112.694 144.986L94.6985 163.855L112.694 174.243L130.692 163.855L112.694 144.986Z",
    fill: "#2C55F2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6985 163.855L112.694 174.243V144.986L94.6985 163.855Z",
    fill: "#8C8CFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3545 132.956L60.0183 146.783L43.5759 137.288L59.9121 123.464L76.3545 132.956Z",
    fill: "#FF775B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3528 132.956L76.3045 154.86L59.9651 164.351L60.0166 146.783L76.3528 132.956Z",
    fill: "#F65F4D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0165 146.783L59.9651 164.351L43.5227 154.86L43.5742 137.292L60.0165 146.783Z",
    fill: "#FF997D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M107.675 164.1C107.71 164.081 107.748 164.062 107.783 164.043L89.6748 174.477C88.4721 175.17 86.4866 175.409 83.9951 175.024C81.4846 174.639 78.9327 173.7 76.839 172.491C74.7453 171.282 73.1098 169.806 72.4288 168.348C71.7415 166.878 72.1488 165.71 73.3643 165.007L91.4726 154.574C92.6595 153.883 94.6514 153.641 97.1555 154.026C99.6661 154.411 102.215 155.35 104.309 156.559C106.399 157.768 108.038 159.245 108.719 160.702C109.428 162.21 108.973 163.404 107.675 164.1Z",
    fill: "url(#paint5_linear)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6504 145.774C95.6624 141.518 89.7146 138.05 82.3654 138.03C75.0163 138.009 69.0488 141.442 69.0368 145.698C69.0247 149.955 74.9725 153.422 82.3217 153.443C89.6708 153.464 95.6383 150.03 95.6504 145.774Z",
    fill: "#FFD4E1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9187 173.481C70.2936 171.966 68.9858 169.978 68.989 167.992L69.0336 145.696C69.0272 147.682 70.3382 149.671 72.9632 151.185C78.1752 154.195 86.601 154.195 91.7811 151.185C94.3553 149.69 95.6408 147.733 95.6472 145.773L95.6026 168.068C95.5963 170.028 94.3076 171.985 91.7366 173.481C86.5564 176.491 78.1307 176.491 72.9187 173.481Z",
    fill: "#FFAEC2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M87.67 152.808C89.1624 152.432 90.5624 151.894 91.7811 151.185C94.3553 149.689 95.6408 147.733 95.6471 145.772L95.6026 168.068C95.5962 170.028 94.3075 171.985 91.7365 173.481C90.5179 174.19 89.1178 174.728 87.6255 175.103L87.67 152.808Z",
    fill: "#FF7994"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3714 66.857L82.637 75.0568C81.8763 74.7005 80.4885 73.8438 79.3817 71.9935C77.7849 69.331 77.6719 64.6572 79.135 60.1992L85.3714 66.857Z",
    fill: "url(#paint6_linear)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M82.9384 64.2598C82.3148 68.3579 82.6369 75.0569 82.6369 75.0569L84.0829 68.9987L83.634 64.9622L82.9384 64.2598Z",
    fill: "#C38C71"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3218 60.446C76.6644 59.8395 77.0756 59.2055 77.5759 58.5339L79.135 60.1992C78.268 62.8411 77.9597 65.5584 78.179 67.8885C77.826 67.6486 77.5073 67.3916 77.2298 67.1209C75.424 65.3871 75.0848 62.6218 76.3218 60.446Z",
    fill: "url(#paint7_linear)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6341 64.9587L89.0617 70.7908C88.6334 74.7827 88.5717 76.5748 88.5717 76.5748C88.5717 76.5748 92.8378 77.2601 95.8498 77.5445C97.1005 77.661 98.0565 78.7164 98.0565 79.9705C98.0565 81.2658 97.0422 82.3349 95.747 82.4068C92.1834 82.6021 89.3222 82.3109 87.1977 81.9031C84.525 81.3926 82.5958 79.0522 82.6164 76.3315C82.6335 73.5526 82.8768 69.2762 83.6341 64.9587Z",
    fill: "url(#paint8_linear)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M89.0616 70.7908L87.9514 69.6052L85.0148 77.2533C83.8875 80.2927 84.7202 80.7621 84.7202 80.7621L86.639 78.7473L89.0616 70.7908Z",
    fill: "#C38C71"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M103.22 81.8073C103.224 82.5029 103.227 83.1574 103.234 83.7159C103.241 84.785 103.923 85.7273 104.934 86.0734C106.349 86.56 107.87 85.7102 108.202 84.2539L108.501 82.9552C108.655 82.2768 108.826 81.6017 109.004 80.9267C106.846 80.0666 104.714 79.6692 103.21 79.4875C103.213 80.2654 103.217 81.0603 103.22 81.8073Z",
    fill: "#C7987D"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M117.78 87.3857C123.448 90.5998 121.635 96.9938 113.737 101.664C105.835 106.338 94.8392 107.52 89.1716 104.306C83.5041 101.092 85.3167 94.698 93.215 90.0276C101.117 85.3537 112.112 84.1716 117.78 87.3857Z",
    fill: "url(#paint9_linear)"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M95.497 105.985C103.103 105.985 109.268 99.8195 109.268 92.2138C109.268 84.608 103.103 78.4424 95.497 78.4424C87.8912 78.4424 81.7256 84.608 81.7256 92.2138C81.7256 99.8195 87.8912 105.985 95.497 105.985Z",
    fill: "#FFCD00"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M102.892 80.5942C102.898 80.6011 102.905 80.6045 102.912 80.6114C107.397 84.5211 107.188 91.8402 102.179 97.0692C96.967 102.507 88.7706 103.429 84.1653 99.0155C83.5348 98.4124 83.014 97.7476 82.5925 97.0315C84.5457 102.26 89.5862 105.982 95.4936 105.982C103.097 105.982 109.265 99.8173 109.265 92.2103C109.265 87.3274 106.726 83.0408 102.892 80.5942Z",
    fill: "#FFBE00"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7024 88.1972C94.1733 86.5447 94.3389 84.291 93.0723 83.1636C91.8057 82.0362 89.5864 82.4619 88.1155 84.1145C86.6446 85.767 86.479 88.0206 87.7456 89.1481C89.0122 90.2755 91.2315 89.8498 92.7024 88.1972Z",
    fill: "#FCE2A1"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M98.896 72.8914C98.7932 72.953 98.6939 73.0147 98.5876 73.0867C98.6904 73.0181 98.7932 72.953 98.896 72.8914Z",
    fill: "#C7987D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1805 73.3711C98.1529 73.3918 98.1253 73.4091 98.0977 73.4298C98.1253 73.4125 98.1529 73.3918 98.1805 73.3711Z",
    fill: "#C7987D"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1331 77.1401C95.1816 76.0368 96.2849 74.9129 97.3506 74.022C96.4254 74.7827 95.3632 75.7969 94.1331 77.1401Z",
    fill: "#C7987D"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M97.707 73.7307C97.6179 73.7992 97.5288 73.8712 97.4363 73.9466C97.5288 73.8712 97.6179 73.8027 97.707 73.7307Z",
    fill: "#C7987D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M120.878 18.9026C106.116 35.1514 98.0531 42.2955 98.0531 42.2955C98.0291 42.3126 90.011 47.7917 83.8671 52.4895C80.7695 54.8573 78.8609 56.8173 77.5725 58.5374L89.0584 70.7942C87.6261 73.2648 86.2212 76.3487 84.9122 79.3024C84.1755 80.9609 83.8226 82.7633 83.8705 84.576C83.9185 86.2687 84.0282 88.472 84.2749 90.4834C84.4119 91.5764 85.3405 92.3954 86.4405 92.3954C87.5164 92.3954 88.4313 91.6107 88.5958 90.5485C88.8048 89.2018 89.0584 87.6222 89.2948 86.1967C89.7917 83.1814 91.1554 80.3784 93.2148 78.1203C93.4992 77.8084 93.8042 77.4829 94.1263 77.1403L94.6334 68.5224L102.182 66.7098L107.572 61.5871L117.968 61.032C118.383 60.3946 118.811 59.7299 119.267 59.0103C127.96 45.3109 117.893 57.7393 143.061 31.718L142.376 30.6523C137.682 23.3263 129.578 18.9026 120.878 18.9026Z",
    fill: "#C7987D"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9864 72.8364C98.9586 72.8538 98.9273 72.8747 98.896 72.8921C98.9273 72.8747 98.9551 72.8538 98.9864 72.8364Z",
    fill: "#C7987D"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5877 73.0867C98.4541 73.1758 98.317 73.2717 98.1765 73.3711C98.3204 73.2683 98.4541 73.1758 98.5877 73.0867Z",
    fill: "#C7987D"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0977 73.4292C97.9675 73.5251 97.8372 73.6245 97.707 73.7273C97.8407 73.6279 97.9709 73.5217 98.0977 73.4292Z",
    fill: "#C7987D"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4376 73.9468C97.4063 73.9711 97.3785 73.9955 97.3472 74.0233C97.3785 73.9955 97.4098 73.9711 97.4376 73.9468Z",
    fill: "#C7987D"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M117.979 61.0251L107.579 61.5802L102.189 66.703L94.6402 68.5156L94.1331 77.1334C95.3632 75.7937 96.4254 74.7794 97.3506 74.0153C97.3814 73.9913 97.4089 73.9673 97.4397 73.9399C97.5322 73.8645 97.6213 73.7925 97.7104 73.724C97.8406 73.6212 97.9708 73.5184 98.101 73.4259C98.1284 73.4053 98.1558 73.3882 98.1833 73.3676C98.3203 73.2683 98.4574 73.1723 98.5944 73.0832C98.7007 73.0113 98.8 72.9496 98.9028 72.8879C98.9337 72.8708 98.9611 72.8502 98.9919 72.8331C102.912 70.4688 103.309 74.1386 103.251 75.218C103.22 75.7902 103.213 77.5686 103.22 79.4875C104.725 79.6691 106.852 80.0666 109.015 80.9267C110.187 76.5441 111.869 72.3088 114.035 68.3169L117.979 61.0251Z",
    fill: "#C7987D"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M120.378 18.9026C105.616 35.1514 98.0566 42.2955 98.0566 42.2955C98.0326 42.3126 90.0144 47.7917 83.8706 52.4895C80.7729 54.8573 78.8643 56.8173 77.576 58.5374C77.0757 59.209 76.6645 59.8429 76.3218 60.4495C76.3116 60.4632 76.3081 60.4803 76.2979 60.4974C76.5686 60.0623 76.9386 59.5688 77.3635 59.3118C78.227 58.7841 79.1385 59.0069 79.1385 59.0069C80.0225 54.4016 91.0938 48.1275 98.7384 42.5902L123.784 19.1322C122.314 18.9026 120.378 18.9026 120.378 18.9026Z",
    fill: "url(#paint10_linear)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.302595,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.735 74.1697L162.482 151.293L94.4893 191.142L94.8769 113.399L162.735 74.1697Z",
    fill: "#BEE9FF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.523411,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.6076 0.926025L0.749023 40.1553L26.5122 74.0889L94.7638 34.9025L68.6076 0.926025Z",
    fill: "url(#paint11_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 164.446,
    y1: 186.142,
    x2: 204.113,
    y2: 90.9031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99C1D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.350953,
    stopColor: "#D1D9DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457393,
    stopColor: "#D9E1E4",
    stopOpacity: 0.83221
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 127.373,
    y1: 144.299,
    x2: 140.585,
    y2: 144.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED2DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#F1F2F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 138.756,
    y1: 151.529,
    x2: 152.77,
    y2: 132.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5A9B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3531,
    stopColor: "#CFD3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(127.354 142.615) scale(4.70887)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000400004,
    stopColor: "#E95E00",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1732,
    stopColor: "#DB5800",
    stopOpacity: 0.4963
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#B54A00",
    stopOpacity: 0.2989
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9494,
    stopColor: "#783300",
    stopOpacity: 0.0304
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#713000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 118.216,
    y1: 161.978,
    x2: 122.84,
    y2: 148.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5A9B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "#CFD3DF",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 77.5972,
    y1: 176.085,
    x2: 94.5866,
    y2: 160.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D5068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3244,
    stopColor: "#00ADDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#D9FCFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 81.5599,
    y1: 72.3037,
    x2: 81.854,
    y2: 62.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9816B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7987D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 76.8564,
    y1: 65.1248,
    x2: 78.5718,
    y2: 60.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9816B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7987D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 89.3608,
    y1: 78.4989,
    x2: 91.5662,
    y2: 69.7508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C38C71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7987D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 93.7101,
    y1: 102.357,
    x2: 117.882,
    y2: 86.2423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5A9B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3531,
    stopColor: "#CFD3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 178.047,
    y1: -36.2347,
    x2: 71.3809,
    y2: 66.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9816B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7987D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 51.1558,
    y1: 60.2321,
    x2: 15.8247,
    y2: 21.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF9FF",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.867b9f53d6a268959edd553faf7da43a.svg";
export { ForwardRef as ReactComponent };